import { Injectable, inject, signal } from '@angular/core';
import { ApiService } from '../../Modules/Shared/Services/api.service';
import { IndexQueryParams, IndexResponse, ResetPasswordPayload, ShowResponse } from '../../Interfaces/api/Intune/users.interface';
import { HttpParams, HttpResourceRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { endpoints } from '../../../environments/endpoints';
import { NoContentResponse } from '../../Modules/Shared/Interfaces/response.interface';

@Injectable({
    providedIn: 'root',
})
export class UsersService {
    private _apiService = inject(ApiService);

    index(queryParams?: IndexQueryParams, skipLoading: boolean = true): HttpResourceRequest {
        const params = this.buildQueryParams(queryParams);
        return this._apiService.get<IndexResponse>(endpoints.api.intune.users.index, { params, skipLoading, });
    }

    show(userId: string, skipLoading: boolean = true): HttpResourceRequest {
        return this._apiService.get<ShowResponse>(endpoints.api.intune.users.show(userId), { skipLoading });
    }

    devices(userId: string, select: string[], skipLoading: boolean = true): HttpResourceRequest {
        let params = new HttpParams();
        select.forEach(field => params = params.append('select[]', field));
        return this._apiService.get<ShowResponse>(endpoints.api.intune.users.devices(userId), { params, skipLoading });
    }

    licenses(userId: string, skipLoading: boolean = true): HttpResourceRequest {
        return this._apiService.get<IndexResponse>(endpoints.api.intune.users.licenses(userId), { skipLoading });
    }

    resetPassword(userId: string, payload: ResetPasswordPayload, skipLoading = false): Observable<NoContentResponse> {
        const request = this._apiService.post<NoContentResponse>(
            endpoints.api.intune.users.resetPassword(userId),
            { body: payload, skipLoading }
        );
        return this._apiService.run<NoContentResponse>(request);
    }

    private buildQueryParams(queryParams?: IndexQueryParams): HttpParams {
        let params = new HttpParams();

        params = params.set('top', queryParams?.top?.toString() ?? '5');
        params = queryParams?.orderBy ? params.set('orderBy', queryParams.orderBy) : params;
        params = queryParams?.search ? params.set('search', queryParams.search) : params;
        params = queryParams?.top ? params.set('top', queryParams.top.toString()) : params;
        params = queryParams?.order ? params.set('order', queryParams.order) : params;
        params = queryParams?.select && queryParams?.select.length > 0 ? queryParams.select.forEach(field => params = params.append('select[]', field)) ?? params : params;
        params = queryParams?.unactiveAvynaUsers != null ? params.set('unactiveAvynaUsers', queryParams.unactiveAvynaUsers ? '1' : '0') : params;

        return params;
    }
}